import axios from 'axios';
import { API_BASE_URL } from '../config';

const noteService = {
  // Credit Notes
  getCreditNotes: async () => {
    const response = await axios.get(`${API_BASE_URL}/credit-notes`);
    return response.data;
  },
  getCreditNote: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/credit-notes/${id}`);
    return response.data;
  },
  createCreditNote: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/credit-notes`, data);
    return response.data;
  },
  updateCreditNote: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/credit-notes/${id}`, data);
    return response.data;
  },
  deleteCreditNote: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/credit-notes/${id}`);
    return response.data;
  },

  // Debit Notes
  getDebitNotes: async () => {
    const response = await axios.get(`${API_BASE_URL}/debit-notes`);
    return response.data;
  },
  getDebitNote: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/debit-notes/${id}`);
    return response.data;
  },
  createDebitNote: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/debit-notes`, data);
    return response.data;
  },
  updateDebitNote: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/debit-notes/${id}`, data);
    return response.data;
  },
  deleteDebitNote: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/debit-notes/${id}`);
    return response.data;
  },
};

export default noteService;
